<section class="ds-modal service-request-flags" aria-labelledby="service_request_flags_title">
    <div class="service-request-flags__header">
        <div class="service-request-flags__heading">
            <ng-container *ngIf="isAddFlag || isResolved">
                <ds-button icon="arrow_back" label="Back" size="sm" theme="tertiary-gray" (buttonClick)="onBack()"></ds-button>
            </ng-container>
            <!-- ds-title renders a span. The dialog needs a real heading that can take the focus. -->
            <h2 class="ds-modal__title service-request-flags__title" id="service_request_flags_title" tabindex="-1">{{ modalTitle }}</h2>
        </div>

        <ds-icon-button icon="close" size="md" theme="tertiary-gray" title="Close" (buttonClick)="closeDialog()"></ds-icon-button>
    </div>

    <ng-container *ngIf="loader">
        <div class="service-request-flags__loader" role="status">
            <ds-loading-spinner class="progress-spinner-v2" [diameter]="32" [strokeWidth]="4"></ds-loading-spinner>
            <ds-text size="sm" theme="tertiary" text="Loading..."></ds-text>
        </div>
    </ng-container>

    <ng-container *ngIf="!loader">
        <ng-container *ngIf="isAddFlag">
            <app-flag-form
                [form]="createServiceRequestFlagForm"
                [isSaving]="isSaving"
                [isUpdateFlag]="isUpdateFlag"
                (cancel)="onBack()"
                (save)="saveServiceRequestFlag()"
            ></app-flag-form>
        </ng-container>

        <ng-container *ngIf="isResolved">
            <app-flag-resolve
                [createdBy]="resolvingFlagCreatedBy"
                [flag]="serviceRequestFlagPayload"
                [isSaving]="isSaving"
                [noteControl]="resolutionNote"
                (cancel)="onBack()"
                (resolve)="resolveServiceRequestFlag()"
            ></app-flag-resolve>
        </ng-container>

        <ng-container *ngIf="!isAddFlag && !isResolved">
            <app-flag-list
                [activeFlags]="activeFlags"
                [activeTab]="activeTab"
                [data]="data"
                [resolvedFlags]="resolvedFlags"
                (activeTabChange)="activeTab = $event"
                (createFlag)="addFlag()"
                (editFlag)="addFlag($event)"
                (resolveFlag)="resolveFlag($event)"
            ></app-flag-list>
        </ng-container>
    </ng-container>
</section>
